import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class MobilizFleetItem {
  fleetId: number;
  fleetName: string;
  companyId: number;
  companyName: string;
  id: string;
}

export class MobilizFleetListResponse extends IPagination {
  @Type(() => MobilizFleetItem)
  results: MobilizFleetItem[];
}

export class MobilizQueryFleetParams extends IQueryPaginationDto {}
